/* global confirm */
import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../../constants/default_constants'
import BasicCItemsForm from './basic_info'
import ExpensesEdit from '../../contracts/parts/expenses'
import HelpOverlay from '../../utils/helpOverlay'
import RightsEdit from '../../contracts/parts/rights'
import SelectionEditor from '../../utils/selection_editor'
import { Tabs, Tab, Button, Modal, Checkbox } from 'react-bootstrap'

const SubmitButton = observer(({ errors, text, ...rest }) => (
  <Button disabled={errors.size > 0} {...rest} bsStyle='primary'>
    {text || 'submit'}
  </Button>
))

const CItemsBatchForm = ({ store }) => {
  if (store.cv.currBatchStore === null) return null
  let form = null
  const batchStore = store.cv.currBatchStore
  const updateField = batchStore.updateData.bind(batchStore)
  const record = batchStore.record
  const errors = batchStore.errors
  const onClose = store.cv.closeBatch.bind(store.cv)

  const onInputHeaderCheckedChange = (attr, checked) => {
    if (checked) {
      batchStore.overwrite.push(attr)
    } else {
      const indx = batchStore.overwrite.indexOf(attr)
      if (indx >= 0) {
        batchStore.overwrite.splice(indx, 1)
      }
    }
  }

  let buttons = (
    <div className='btn-group' role='group'>
      <SubmitButton errors={batchStore.errors} onClick={() => batchStore.save()} />
      <Button onClick={onClose}>close</Button>
    </div>
  )
  switch (store.cv.currBatchAction) {
  case 'addex':
    form = (
      <ExpensesEdit store={store} state={batchStore.limitsstate}
        items={record.get('limits')} attr={'limits'} />
    )
    buttons = (
      <div className='btn-group' role='group'>
        <Button bsStyle='primary' errors={batchStore.errors} onClick={() => batchStore.save()}>
          <i className='glyphicon glyphicon-resize-small' />&nbsp; {store.__('Merge')} <HelpOverlay store={store} top path='batch/merge' />
        </Button>
        <Button bsStyle='primary' onClick={() => {
          if (confirm('Are you sure you want to overwrite?')) {
            batchStore.save(batchStore.overwrite.bind(batchStore))
          }
        }}>
          <i className='glyphicon glyphicon-retweet' />&nbsp; {store.__('Overwrite')} <HelpOverlay store={store} top path='batch/overwrite' />
        </Button>
        <Button bsStyle='default' onClick={onClose}>
          <i className='glyphicon glyphicon-remove' />&nbsp; {store.__(defaultConst.TITLE_CANCEL)}
        </Button>
      </div>
    )
    break
  case 'addRights':
    form = (
      <RightsEdit store={store} state={batchStore.rightsstate}
        items={record.get('rights')} attr={'rights'} />
    )
    buttons = (
      <div className='btn-group' role='group'>
        <Button bsStyle='primary' errors={batchStore.errors} onClick={() => batchStore.save()}>
          <i className='glyphicon glyphicon-resize-small' />&nbsp; {store.__('Merge')} <HelpOverlay store={store} top path='batch/merge' />
        </Button>
        <Button bsStyle='primary' onClick={() => {
          if (confirm('Are you sure you want to overwrite?')) {
            batchStore.save(batchStore.overwrite.bind(batchStore))
          }
        }}>
          <i className='glyphicon glyphicon-retweet' />&nbsp; {store.__('Overwrite')} <HelpOverlay store={store} top path='batch/overwrite' />
        </Button>
        <Button bsStyle='default' onClick={onClose}>
          <i className='glyphicon glyphicon-remove' />&nbsp; {store.__(defaultConst.TITLE_CANCEL)}
        </Button>
      </div>
    )
    break
  case 'set':
    form = <BasicCItemsForm
      store={store} updateField={updateField} record={record}
      errors={errors} onHeaderCheckedChange={['overwrite', onInputHeaderCheckedChange]} />
    break
  }
  return (
    <Modal show backdrop='static' onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{batchStore.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs id='tabbs'>
          <Tab title='Form' eventKey={1}>
            {form}
          </Tab>
          <Tab title='Selection' eventKey={2}>
            <SelectionEditor store={store} />
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        {
          batchStore.conflictingItems.length > 0 && (
            <p className='bg-danger'><b>WARNING:</b>&nbsp; Conflicting items, go to selection for list.</p>
          )
        }
        {buttons}
      </Modal.Footer>
    </Modal>
  )
}
export default observer(CItemsBatchForm)
